import React, { useEffect, useRef } from 'react';
import { Camera, Video, Scissors } from 'lucide-react';

const Services = () => {
  const servicesRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          const cards = entry.target.querySelectorAll('.service-card');
          cards.forEach((card, index) => {
            setTimeout(() => {
              card.classList.add('animate-slide-up');
            }, index * 200);
          });
        }
      },
      { threshold: 0.1 }
    );

    if (servicesRef.current) {
      observer.observe(servicesRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const services = [
    {
      icon: Camera,
      title: 'Fotografi',
      description: 'Mengabadikan momen berharga dengan komposisi yang sempurna dan teknik fotografi profesional untuk berbagai kebutuhan.'
    },
    {
      icon: Video,
      title: 'Videografi',
      description: 'Menciptakan video berkualitas tinggi yang menceritakan kisah Anda dengan sinematografi yang memukau dan naratif yang kuat.'
    },
    {
      icon: Scissors,
      title: 'Editing Video',
      description: 'Mengolah footage menjadi karya visual yang menawan dengan teknik editing terdepan dan efek visual yang memikat.'
    }
  ];

  return (
    <section id="services" ref={servicesRef} className="py-20 lg:py-32 bg-gray-50 dark:bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-6">
            Layanan Kami
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Kami menawarkan solusi visual lengkap untuk semua kebutuhan kreatif Anda
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div 
                key={index}
                className="service-card opacity-0 transform translate-y-10 transition-all duration-700 bg-white dark:bg-gray-900 p-8 rounded-2xl shadow-xl hover:shadow-2xl hover:-translate-y-2 group"
              >
                <div className="mb-6">
                  <div className="w-16 h-16 bg-gray-900 dark:bg-white rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <IconComponent size={32} className="text-white dark:text-gray-900" />
                  </div>
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-4 group-hover:text-gray-700 dark:group-hover:text-gray-300 transition-colors duration-200">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;